import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import Schema from 'async-validator';
import ptBr from 'antd/es/locale/pt_BR';
import sentry from './services/util/sentry';
import 'antd/dist/antd.less';
import './styles/global.less';
import reportWebVitals from './reportWebVitals';
import Router from './Router';
import CookiesProvider from './cookiesProvider';

sentry.initialize(process.env.REACT_APP_SENTRY_DNS, process.env.NODE_ENV);

// https://stackoverflow.com/questions/64128556/ant-design-form-async-validator-warning
Schema.warning = () => null;

ReactDOM.render(
  <CookiesProvider>
    <React.StrictMode>
      <ConfigProvider locale={ptBr}>
        <Router />
      </ConfigProvider>
    </React.StrictMode>
  </CookiesProvider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
